import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class ConfigurationStoreService {
  CONFIGURATION_EMAILS: any;
  CONFIGURATION_PHONES: any;
  CONFIGURATION_ACCOUNT: any;
  CONFIGURATION_PERSONERIA: any;
  CONFIGURATION_DIRECTION: any;
  CONFIGURATION_PERSONAL_INFORMATION: any;
  //
  constructor() {}
}
